/** Where the user is rendered from — drives active highlight on global links. */
export type GlobalNavSurface =
    | "www_map"
    | "www_stats"
    | "www_other"
    | "todo"
    | "qr"
    | "opinion"
    | "styre"
    | "chat";

export type GlobalNavItemId = "map" | "todo" | "qr" | "stats" | "chat" | "opinion";

export type GlobalNavUrls = Record<GlobalNavItemId, string>;

const defaultSubdomains = {
    todo: "https://todo.centerreach.se/",
    qr: "https://qr.centerreach.se/",
    chat: "https://chat.centerreach.se/",
    opinion: "https://opinion.centerreach.se/"
} as const;

/**
 * Build absolute URLs for global nav. Pass wwwOrigin so map + stats stay on the same host as the main app (e.g. dev localhost).
 */
export function createGlobalNavUrls(wwwOrigin: string): GlobalNavUrls {
    const base = wwwOrigin.replace(/\/$/, "");
    return {
        map: `${base}/`,
        stats: `${base}/stats`,
        todo: defaultSubdomains.todo,
        qr: defaultSubdomains.qr,
        chat: defaultSubdomains.chat,
        opinion: defaultSubdomains.opinion
    };
}

export function getActiveNavItemId(surface: GlobalNavSurface): GlobalNavItemId | null {
    switch (surface) {
        case "www_map":
            return "map";
        case "www_stats":
            return "stats";
        case "todo":
            return "todo";
        case "qr":
            return "qr";
        case "opinion":
            return "opinion";
        case "styre":
            return null;
        case "chat":
            return "chat";
        default:
            return null;
    }
}

export const globalNavItemOrder: GlobalNavItemId[] = ["map", "todo", "qr", "stats", "chat", "opinion"];

export const globalNavLabelsSv: Record<GlobalNavItemId, string> = {
    map: "Karta",
    todo: "Todo",
    qr: "QR",
    stats: "Statistik",
    chat: "Chat",
    opinion: "Opinion"
};

/** Label on the menu trigger: current app when known, otherwise "Meny". */
export function getGlobalNavTriggerLabel(surface: GlobalNavSurface): string {
    if (surface === "styre") {
        return "Styre";
    }
    const id = getActiveNavItemId(surface);
    return id ? globalNavLabelsSv[id] : "Meny";
}
